<template>
<div class="chapter">
<div class="inner_page">
<p class="title">TREACHEROUS<br/>ALLIANCE<br/><br/><br/></p>
<p class="subtitle">the secret dealings of<br/>Israel, Iran, and the<br/>United States<br/><br/><br/></p>
<p class="author">trita parsi<br/><br/></p>
<p class="publisher">yale university press / new haven and london</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02-titlepage.vue?1a718b1c